import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { SesionvService } from '../core/services/sesionv.service';

declare var $: any;

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {

  linkDc = environment.enlaceBuscaCredito;
  Bc = environment.buscacredito;

  constructor(public sesionv: SesionvService) { }

  ngOnInit() {
    
  }
} 